module.exports = __webpack_public_path__ + "static/apple-icon-152x152-0dc2bc86541d2797b3a477eddfa40531.png";